import Button from 'components/General/Button/Button';
import { useEffect, useState } from 'react';
import { CheckboxGroup } from 'react-rainbow-components';
import { useDispatch, useSelector } from 'react-redux';
import { setFilter, StudentsSlice, toggleFiltersModal } from '../../StudentsSlice';
import './ClassFilter.scss';

const ClassFilters = () => {
  const dispatch = useDispatch();
  const studentsState = useSelector((state: { teacherStudents: StudentsSlice }) => state.teacherStudents);
  const [values, setVlaues] = useState<string[] | undefined>(studentsState.filter.courses);

  const handleApplyFilters = () => {
    dispatch(setFilter({ courses: values }));
    dispatch(toggleFiltersModal(false));
  };

  const options = [
    { value: 'SAT', label: 'SAT', disabled: false },
    { value: 'GMAT', label: 'GMAT', disabled: false },
    { value: 'IELTS', label: 'IELTS', disabled: false },
  ];

  useEffect(() => {
    setVlaues(studentsState.filter.courses);
  }, [studentsState.filter.courses]);

  return (
    <div className="class-filter-container">
      <h2>Class</h2>
      <div className="filters-container">
        <CheckboxGroup
          options={options}
          value={values}
          onChange={(e) => setVlaues(e)}
          className="checkbox"
        />
      </div>
      <div className="mt-3">
        <Button
          color="primary"
          onClick={handleApplyFilters}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default ClassFilters;
